<template>
  <div class="widget border-0">
    <div class="header border-0">
      <div class="title border-0">
        {{ __(title) }}
      </div>
    </div>
    <div
      class="body mt-4 border-0"
      v-if="loading"
    >
      <span class="loading border-0"><i class="fa fa-circle-o-notch fa-spin" /></span>
    </div>
    <div
      :class="list.length === 0 ? 'body mt-4 border-0 h-100' : 'body mt-5 border-0'" style="min-height:300px;"
      v-else
    >
      <div v-if="list.length === 0" class="h-100 d-flex flex-column justify-content-center align-items-center">
        <h2 style="font-weight: 700;font-size: 1.375rem;text-align: center;">
          {{ __('Nenhum dado foi encontrado neste período!') }}
        </h2>
        <h3 style="font-size: 1.125rem;font-weight: 400;text-align: center;">
          {{ __('Já tentou alterar as datas?') }}
        </h3>
      </div>

      <div v-else>
        <div
          class="deal-user border-0 p-0 m-0"
          v-for="(user, index) in list"
          :key="index"
          v-if="index < 5"
        >
          <div
            class="media"
          >
            <a
              class="float-left title"
              href="#"
            >
              <Avatar
                class="rounded-circle"
                :name="getUserName(user.id) || getUserEmail(user.id)"
                :url="getUserGravatar(user.id)"
                width="32"
              /></a><span class="mt-2 ml-2">{{ getUserName(user.id) || getUserEmail(user.id) }}</span>
            <div class="mt-2 ml-auto">
              <span
                class="f-w-700 mr-1"
                :class="color"
              >{{ user.total | currency(0) }}</span><span class="text-salesflow-font-gray">{{ __('em') }} {{ user.count | number(0) }} {{ plural(user.count) }}</span>
            </div>
          </div>
          <hr class="hr-style">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import progresWidget from '../../mixins/progress-widget';

export default {
  mixins: [progresWidget],

  props: ['name'],

  data () {
    return {
      interval: 'one',
    };
  },

  computed: {
    title () {
      const title = {
        'deal.started': 'iniciados',
        'deal.lost': 'perdidos',
        'deal.won': 'ganhos',
      };

      return this.__(`Usuários com mais negócios ${title[this.name]}`);
    },

    color () {
      const className = {
        'deal.started': 'color-salesflow-primary',
        'deal.lost': 'color-salesflow-info',
        'deal.won': 'color-salesflow-secondary',
      };

      return className[this.name];
    },
  },

  methods: {
    plural (count = 0) {
      const {
        __,
      } = this;

      return count > 1 ? __('negócios') : __('negócio');
    },
  },
};
</script>
<style>
.title {
  pointer-events: none;
}
.title:hover {
  text-decoration: none;
}
.hr-style {
  border-color: #D1D1D1;
}
</style>
